export var TagGroupType;
(function (TagGroupType) {
    TagGroupType["External"] = "EXTERNAL";
    TagGroupType["PhraseSearch"] = "PHRASE_SEARCH";
    TagGroupType["Agent"] = "AGENT";
})(TagGroupType || (TagGroupType = {}));
//# sourceMappingURL=tag-groups.js.map